import { scaffolderTranslationRef } from "@backstage/plugin-scaffolder/alpha";
import { createTranslationResource } from '@backstage/frontend-plugin-api';
import { TranslationBlueprint } from '@backstage/plugin-app-react';

export const scaffolderTranslations: any = TranslationBlueprint.make({
  name: 'scaffolder-pt-BR',

  params: {
    resource: createTranslationResource({
      ref: scaffolderTranslationRef,
      translations: {
        'pt-BR': () => import('./scaffolder-ptbr'),
      },
    }),
  },
});